import React from 'react';
import { MutatingDots } from 'react-loader-spinner';
import './Spinner.style.scss';

export default function Spinner({ primaryColor, secondaryColor }: { primaryColor?: string; secondaryColor?: string }) {
  return (
    <section className="SpinnerComponent">
      <MutatingDots
        height="100"
        width="100"
        color={primaryColor}
        secondaryColor={secondaryColor}
        ariaLabel="loading-indicator"
      />
    </section>
  );
}
